"use client"
import { Outlet } from "react-router-dom"
import { AppBackground } from "@/components/app-background"
import { AppSidebar } from "@/components/app-sidebar"
import { SiteHeader } from "@/components/site-header"
import {
    SidebarInset,
    SidebarProvider,
} from "@/components/ui/sidebar"
import { useScrollContext } from "@/contexts/scroll-context"
import { AppErrorBoundary } from "@/components/app-error-boundary"

export function DashboardLayout() {
    const { allowScroll } = useScrollContext()
    return (
        // Lock the shell to the viewport. Only SidebarInset (or a page that opts
        // out via allowScroll=false) should scroll — never the outer shell too,
        // or mobile gets nested page + content scrollbars.
        <div className="relative h-[100dvh] overflow-hidden [--header-height:calc(--spacing(14)+env(safe-area-inset-top))]">
            <AppBackground />
            <SidebarProvider className="relative z-10 flex h-full flex-col">
                <SiteHeader />
                <div className="flex min-h-0 flex-1 overflow-hidden pt-[var(--header-height)]">
                    <AppSidebar />
                    <SidebarInset
                        className={`h-full min-h-0 min-w-0 ${allowScroll ? "overflow-y-auto" : "overflow-hidden"}`}
                    >
                        <AppErrorBoundary context="generic">
                            <Outlet />
                        </AppErrorBoundary>
                    </SidebarInset>
                </div>
            </SidebarProvider>
        </div>
    )
}

